import { useEffect, useState } from 'react'

import { useMotionValue, animate } from 'framer-motion'

interface AnimatedNumberProps {
  value: number
  duration?: number
  className?: string
}

export function AnimatedNumber({
  value,
  duration = 0.8,
  className
}: AnimatedNumberProps) {
  const motionValue = useMotionValue(value)
  const [displayValue, setDisplayValue] = useState(value)

  useEffect(() => {
    const controls = animate(motionValue, value, {
      duration,
      onUpdate: v => setDisplayValue(Math.round(v))
    })
    return controls.stop
  }, [value, duration, motionValue])

  return <span className={className}>{displayValue}</span>
}
